import { render, staticRenderFns } from "./ValueObjectListAdmin.vue?vue&type=template&id=9da7ce6c&"
import script from "./ValueObjectListAdmin.vue?vue&type=script&lang=js&"
export * from "./ValueObjectListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports